
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from './pipes.module';
import { DirectivesModule } from './directives.module';

import { BbCheckComponent } from '../components/shared/bb-check/bb-check.component';
import { BbChecklistItemComponent } from '../components/shared/bb-checklist-item/bb-checklist-item.component';
import { BbSearchSelectComponent } from '../components/shared/bb-search-select/bb-search-select.component';
import { BbRadioComponent } from './../components/shared/bb-radio/bb-radio.component';
import { BbDatepickerComponent } from '../components/shared/bb-datepicker/bb-datepicker.component';
import { BbTooltipComponent } from '../components/shared/bb-tooltip/bb-tooltip.component';
import { BbSelectComponent } from '../components/shared/bb-select/bb-select.component';
import { BbSliderComponent } from './../components/shared/bb-slider/bb-slider.component';
import { BbInfoComponent } from '../components/shared/bb-info/bb-info.component';
import { BbWarningComponent } from '../components/shared/bb-warning/bb-warning.component';
import { BbStatusComponent } from '../components/shared/bb-status/bb-status.component';
import { BbFormElementComponent } from '../components/shared/bb-form-element/bb-form-element.component';
import { BbRealtimeViewersComponent } from '../components/shared/bb-realtime-viewers/bb-realtime-viewers.component';
import { BbChecklistComponent } from '../components/shared/bb-checklist/bb-checklist.component';
import { BbSidebarDetailsComponent } from '../components/shared/bb-sidebar-details/bb-sidebar-details.component';
import { BbKpiPerformanceComponent } from '../components/shared/bb-kpi-performance/bb-kpi-performance.component';
import { BbKpiBlockComponent } from '../components/shared/bb-kpi-block/bb-kpi-block.component';


import { BbRadioListComponent } from '../components/shared/bb-radio-list/bb-radio-list.component';
import { BbIconListComponent } from '../components/shared/bb-icon-list/bb-icon-list.component';
import { BbIconToggleComponent } from './../components/shared/bb-icon-toggle/bb-icon-toggle.component';
import { BbCheckboxListComponent } from '../components/shared/bb-checkbox-list/bb-checkbox-list.component';
import { BbPositionComponent } from '../components/shared/bb-position/bb-position.component';
import { BbFloatingLabelComponent } from 'app/components/shared/bb-floating-label/bb-floating-label.component';

import { RouterModule } from '@angular/router';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		DirectivesModule,
		PipesModule,
		RouterModule
	],
	declarations: [
		BbFormElementComponent,
		BbCheckComponent,
		BbSearchSelectComponent,
		BbRadioComponent,
		BbDatepickerComponent,
		BbSelectComponent,
		BbSliderComponent,
		BbTooltipComponent,
		BbInfoComponent,
		BbWarningComponent,
		BbStatusComponent,
		BbRealtimeViewersComponent,
		BbChecklistItemComponent,
		BbChecklistComponent,
		BbSidebarDetailsComponent,
		BbKpiPerformanceComponent,
		BbKpiBlockComponent,
		BbRadioListComponent,
		BbIconListComponent,
		BbIconToggleComponent,
		BbCheckboxListComponent,
		BbPositionComponent,
		BbFloatingLabelComponent
	],
	exports: [
		BbFormElementComponent,
		BbCheckComponent,
		BbSearchSelectComponent,
		BbRadioComponent,
		BbDatepickerComponent,
		BbSelectComponent,
		BbSliderComponent,
		FormsModule,
		ReactiveFormsModule,
		BbTooltipComponent,
		BbInfoComponent,
		BbWarningComponent,
		BbStatusComponent,
		BbRealtimeViewersComponent,
		BbChecklistItemComponent,
		BbChecklistComponent,
		BbSidebarDetailsComponent,
		BbKpiPerformanceComponent,
		BbKpiBlockComponent,
		BbRadioListComponent,
		BbIconListComponent,
		BbIconToggleComponent,
		BbCheckboxListComponent,
		BbPositionComponent,
		BbFloatingLabelComponent
	]
})
export class InputsModule {

}
